import { CIMSModule, CIMSPage, Permission } from '@cims-online/shared'
import { useProtectedMenuItem } from './useProtectedMenuItem'

export function useMaterials() {
  return useProtectedMenuItem({
    module: CIMSModule.Materials,
    pages: [
      {
        page: CIMSPage.ConcreteMixDesigns,
        permission: Permission.ViewConcreteMixDesign,
      },
      {
        page: CIMSPage.AsphaltMixDesigns,
        permission: [
          Permission.ViewAsphaltMixDesign,
          Permission.ViewLIMSAsphaltMixDesignTarget,
        ],
      },
    ],
  })
}
